export default __webpack_public_path__ + "static/media/medium.8bccc475.svg";